import mutations from './ebeutalo.mutations'
import actions from './ebeutalo.actions'
import getters from './ebeutalo.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
